"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE = exports.PLACEMENTS = exports.ENTER_DELAY = void 0;
Object.defineProperty(exports, "TOOLTIP_STYLES", {
  enumerable: true,
  get: function get() {
    return _constants.TOOLTIP_STYLES;
  }
});
exports.default = exports.TRIGGERS = void 0;
var _react = _interopRequireWildcard(require("react"));
var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("rc-tooltip/assets/bootstrap_white.css");
var _styles = _interopRequireDefault(require("./styles"));
var _constants = require("./constants");
var _excluded = ["children", "isTrue"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_ENTER_DELAY_SECONDS = 1;
var ENTER_DELAY = exports.ENTER_DELAY = {
  NOW: 0
};
var PLACEMENTS = exports.PLACEMENTS = {
  BOTTOM_LEFT: 'bottomLeft',
  TOP: 'top',
  TOP_LEFT: 'topLeft'
};
var TRIGGERS = exports.TRIGGERS = {
  CLICK: 'click',
  HOVER: 'hover'
};
var SIZE = exports.SIZE = {
  MEDIUM: 'md',
  LARGE: 'lg'
};
var TooltipWrapper = function TooltipWrapper(_ref) {
  var align = _ref.align,
    children = _ref.children,
    content = _ref.content,
    className = _ref.className,
    getTooltipContainer = _ref.getTooltipContainer,
    _ref$enterDelay = _ref.enterDelay,
    enterDelay = _ref$enterDelay === void 0 ? DEFAULT_ENTER_DELAY_SECONDS : _ref$enterDelay,
    placement = _ref.placement,
    trigger = _ref.trigger,
    _ref$showArrow = _ref.showArrow,
    showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow,
    size = _ref.size,
    onPopupAlign = _ref.onPopupAlign,
    onVisibleChange = _ref.onVisibleChange,
    overlayInnerStyle = _ref.overlayInnerStyle;
  return /*#__PURE__*/_react.default.createElement(_rcTooltip.default, {
    destroyTooltipOnHide: true,
    align: align,
    getTooltipContainer: getTooltipContainer,
    mouseEnterDelay: enterDelay,
    overlay: content,
    overlayClassName: (0, _classnames2.default)(className, _defineProperty(_defineProperty({}, _styles.default["size--".concat(size)], !!size), _styles.default.hideArror, !showArrow)),
    placement: placement,
    trigger: trigger,
    onPopupAlign: onPopupAlign,
    onVisibleChange: onVisibleChange,
    overlayInnerStyle: overlayInnerStyle
  }, children);
};
TooltipWrapper.propTypes = {
  align: _propTypes.default.shape({
    offset: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
    // [20%, 30] | [30, 30]
    targetOffset: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])),
    // [20%, 30] | [30, 30],
    overflow: _propTypes.default.shape({
      adjustX: _propTypes.default.bool,
      adjustY: _propTypes.default.bool
    }) // auto adjust position when sourceNode is overflowed
  }),
  children: _propTypes.default.any.isRequired,
  content: _propTypes.default.any.isRequired,
  className: _propTypes.default.string,
  enterDelay: _propTypes.default.number,
  getTooltipContainer: _propTypes.default.func,
  placement: _propTypes.default.oneOf(Object.values(PLACEMENTS)),
  size: _propTypes.default.oneOf(Object.values(SIZE)),
  trigger: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOf(Object.values(TRIGGERS))), _propTypes.default.string]),
  showArrow: _propTypes.default.bool,
  onPopupAlign: _propTypes.default.func,
  onVisibleChange: _propTypes.default.func,
  overlayInnerStyle: _propTypes.default.oneOf(Object.values(_constants.TOOLTIP_STYLES))
};
var Tooltip = (0, _react.memo)(TooltipWrapper);
Tooltip.RenderWhen = function (_ref2) {
  var children = _ref2.children,
    isTrue = _ref2.isTrue,
    props = _objectWithoutProperties(_ref2, _excluded);
  return isTrue ? /*#__PURE__*/_react.default.createElement(Tooltip, props, children) : children;
};
Tooltip.RenderWhen.propTypes = {
  children: _propTypes.default.any,
  isTrue: _propTypes.default.bool
};
Tooltip.RenderWhen.displayName = 'Tooltip.RenderWhen';
var _default = exports.default = Tooltip;